function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { styled } from '@airwallex/theme';

var CardStyles = function CardStyles(_ref) {
  var _ref2, _ref3;

  var theme = _ref.theme,
      transparent = _ref.transparent,
      clickable = _ref.clickable,
      hoverable = _ref.hoverable;
  return _objectSpread(_objectSpread(_objectSpread({
    display: 'block',
    padding: 0,
    font: 'inherit',
    color: 'inherit',
    background: 'none',
    textAlign: 'left',
    textDecoration: 'none',
    outline: 'none',
    position: 'relative',
    border: "1px solid ".concat(theme.colors.greys[20]),
    borderRadius: theme.radius.l
  }, !transparent && {
    backgroundColor: theme.colors.white,
    boxShadow: "0 0 ".concat(theme.space.s, " 0 rgba(0, 0, 0, 0.08)")
  }), clickable && (_ref2 = {
    cursor: 'pointer'
  }, _defineProperty(_ref2, "h1, h2, h3, h4, h5, h6", {
    transition: 'color .3s'
  }), _defineProperty(_ref2, "&:active,\n      &:focus,\n      &:hover", {}), _ref2)), hoverable && (_ref3 = {}, _defineProperty(_ref3, "&, h1, h2, h3, h4, h5, h6", {
    transition: 'all .3s'
  }), _defineProperty(_ref3, "&:active,\n      &:focus,\n      &:hover", _defineProperty({
    backgroundColor: theme.colors.white,
    boxShadow: "0 0 ".concat(theme.space.s, " 0 rgba(0, 0, 0, 0.08)")
  }, "h1, h2, h3, h4, h5, h6", {
    color: theme.colors.ultraViolets['80']
  })), _ref3));
};

export var Card = styled.article(CardStyles);
export var CardLink = styled.a(function (_ref4) {
  var theme = _ref4.theme,
      href = _ref4.href;
  return CardStyles({
    theme: theme,
    transparent: true,
    clickable: !!href,
    hoverable: !!href
  });
});
export var CardButton = styled.button(function (_ref5) {
  var theme = _ref5.theme,
      disabled = _ref5.disabled;
  return CardStyles({
    theme: theme,
    transparent: true,
    clickable: !disabled,
    hoverable: !disabled
  });
}, {
  // buttons are not going full width when display block
  // need to force the width to 100%
  width: '100%'
});
export var CardBody = styled.div(function (_ref6) {
  var theme = _ref6.theme,
      _ref6$size = _ref6.size,
      size = _ref6$size === void 0 ? 'xl' : _ref6$size;
  return _objectSpread(_objectSpread({
    label: 'Card_CardBody',
    padding: theme.space[size]
  }, size === 'xl' && {
    paddingTop: theme.space.l,
    paddingBottom: theme.space.l
  }), {}, _defineProperty({}, theme.breakpoints.breakpoint.s, _objectSpread({
    padding: theme.space.s
  }, size === 'xl' && {
    paddingTop: theme.space.m
  })));
});
export var CardToolbar = styled(CardBody)(function (_ref7) {
  var theme = _ref7.theme;
  return _defineProperty({
    paddingTop: theme.space.m,
    paddingBottom: theme.space.s
  }, "& + [class*=\"Card_CardBody\"]", {
    paddingTop: 0
  });
});
export var CardImage = styled(CardBody)(function (_ref9) {
  var theme = _ref9.theme,
      _ref9$gradient = _ref9.gradient,
      gradient = _ref9$gradient === void 0 ? true : _ref9$gradient;
  return _objectSpread(_objectSpread(_defineProperty({
    label: 'Card_CardImage'
  }, '&&', {
    paddingBottom: 0
  }), gradient && {
    background: 'linear-gradient(to bottom, transparent 0%, rgba(0, 0, 0, 0.04) 100%)',
    backgroundSize: "100% calc(100% - ".concat(theme.space.m, ")"),
    backgroundRepeat: 'no-repeat'
  }), {}, _defineProperty({}, "& + [class*=\"Card_CardBody\"]", {
    paddingTop: theme.space.s
  }));
});
export var CardHeader = styled(CardBody)(function (_ref10) {
  var _ref11;

  var theme = _ref10.theme;
  return _ref11 = {
    label: 'Card_CardHeader',
    paddingBottom: theme.space.m,
    borderBottom: "1px solid ".concat(theme.colors.greys[20])
  }, _defineProperty(_ref11, theme.breakpoints.breakpoint.s, {
    paddingTop: theme.space.m
  }), _defineProperty(_ref11, "& + [class*=\"Card_CardImage\"]", {
    paddingTop: theme.space.s
  }), _ref11;
}).withComponent('header', {
  target: "eu0ngp0",
  label: "CardHeader"
});
export var CardSeparator = styled.div(function (_ref12) {
  var theme = _ref12.theme,
      size = _ref12.size;
  return _objectSpread(_objectSpread({
    borderBottom: "1px solid ".concat(theme.colors.greys[20])
  }, size && {
    marginLeft: theme.space[size],
    marginRight: theme.space[size]
  }), size && _defineProperty({}, theme.breakpoints.breakpoint.s, {
    marginLeft: theme.space.s,
    marginRight: theme.space.s
  }));
});
export default Card;